import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../Types';
import { T } from '../../../../../../../../Translations';
import CompetencyOverview from './CompetencyOverview';
import CompetencyList from './CompetencyList';

export interface Props {
  resource: ExperienceResource;
}

const Competencies: React.FC<Props> = ({ resource }) => (
  <div className="flex flex-col px-10 pt-8 mb-5">
    <div className="mb-2 text-sm font-medium">
      <T kind={'Competencies'} />
      <CompetencyOverview resource={resource} />
    </div>
    <div className="flex flex-wrap gap-x-2 gap-y-2">
      <CompetencyList resource={resource} />
    </div>
  </div>
);

export default observer(Competencies);
